import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Tag from 'shared/components/Tag';
import styles from './styles.module.scss';

const AddLanguageToProfile = ({ entity, setModalData }) => {
  const { t } = useTranslation('userportal');

  const handleLanguageClick = () => {
    const newLevel = entity.levelId < 6 ? entity.levelId + 1 : 1;
    setModalData(prev => ({
      ...prev,
      entity: {
        ...prev.entity,
        levelId: newLevel
      }
    }));
  };

  if (!entity) {
    return null;
  }

  return (
    <div>
      <p>
        {t('page.job.add_languageToProfileDescription')}
      </p>
      <div className={styles.tagLine}>
        <Tag
          noTooltip
          type="language"
          slug={entity.slug}
          level={entity.levelId}
          onClick={handleLanguageClick}
        />
      </div>
      <p>
        {t('page.job.add_languageToProfileDescription2')}
      </p>
      <p>
        <strong>{t('page.job.selectedLevel')}</strong>: {t(`common:languageLevel.${entity.levelId}`)}
      </p>
    </div>
  );
};

AddLanguageToProfile.propTypes = {
  entity: PropTypes.shape({
    languageId: PropTypes.number,
    slug: PropTypes.string,
    levelId: PropTypes.number
  }),
  setModalData: PropTypes.func
};

AddLanguageToProfile.defaultProps = {
  entity: null,
  setModalData() {}
};

export default AddLanguageToProfile;
